import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const TextLinkIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7396 12.334H2.0729V1.66732C2.0729 1.66732 5.0729 1.66732 7.0729 1.66732C7.73956 1.66732 7.73956 0.333984 7.0729 0.333984C5.0729 0.333984 2.0729 0.333984 2.0729 0.333984C1.3329 0.333984 0.739563 0.933984 0.739563 1.66732V12.334C0.739563 13.0673 1.3329 13.6673 2.0729 13.6673H12.7396C13.4729 13.6673 14.0729 13.0673 14.0729 12.334C14.0729 12.334 14.0729 10.0007 14.0729 7.33398C14.0729 6.66732 12.7396 6.66732 12.7396 7.33398C12.7396 10.0007 12.7396 12.334 12.7396 12.334ZM9.40623 0.333984C8.73956 0.333984 8.73956 1.33398 9.40623 1.66732C10.7396 2.33398 10.7396 2.33398 10.7396 2.33398C10.7396 2.33398 7.40623 5.66732 4.73956 8.33398C3.73956 9.33398 5.0729 10.6673 6.0729 9.66732C8.73956 7.00065 12.0729 3.66732 12.0729 3.66732C12.0729 3.66732 12.0729 3.66732 12.7396 5.00065C13.0729 5.66732 14.0729 5.66732 14.0729 5.00065C14.0729 3.00065 14.0729 0.333984 14.0729 0.333984C14.0729 0.333984 11.4062 0.333984 9.40623 0.333984Z"
        fill={props.fill || `#0557D5`}
      />
    </SvgIcon>
  );
};

export default TextLinkIcon;
